import * as amplitude from "@amplitude/analytics-browser"
import { AnalyticsWindow } from "./analytics-window"
import { EnrichmentPlugin } from "@amplitude/analytics-types"
import getConsentsData, {
  setConsentsDataOnUserProperty,
} from "./analytics-consents"
import analyticsWebVitals from "./analytics-web-vitals"
import analyticsWistia from "./analytics-wistia"
import getOptimizelyData, {
  setOptimizelyDataOnUserProperty,
  sendEventToOptimizely,
} from "./analytics-optimizely"

declare let window: AnalyticsWindow

interface AnalyticsLoaderProps {
  apiKey: string
}

export default function analyticsLoader(
  _el: HTMLElement,
  props: AnalyticsLoaderProps,
) {
  function eventTrackingEnrichment(): EnrichmentPlugin {
    return {
      name: "event-tracking-enrichment",
      type: "enrichment",
      setup: async () => undefined,
      execute: async event => {
        const url = window.location.href
        const path = window.location.pathname
        const pageTitle = document.title

        event.event_properties = {
          ...event.event_properties,
          "Page url": url,
          "Page path": path,
          "Page title": pageTitle,
          Context: "Marketing website",
        }
        if (event.event_type !== "[Amplitude] Page Viewed") {
          return event
        }

        setOptimizelyDataOnUserProperty()
        sendEventToOptimizely("marketing_page_viewed")
        event.event_type = "Marketing Page Viewed"

        event.event_properties = {
          ...event.event_properties,
          "Browser language": navigator.language,
          ...getOptimizelyData(),
          ...getConsentsData(),
        }
        return event
      },
    }
  }

  amplitude.add(eventTrackingEnrichment())

  amplitude.init(props.apiKey, {
    optOut:
      window.parent.location.pathname.includes("/ca-admin") ||
      window.location.search.includes("optimizely"),
    autocapture: {
      formInteractions: false,
      fileDownloads: false,
      elementInteractions: false,
    },
  })

  // Web Vitals
  analyticsWebVitals()

  // Wistia
  analyticsWistia()

  document.addEventListener("cookieConsentPreferencesUpdated", () => {
    setConsentsDataOnUserProperty()
  })

  document.addEventListener("cookieConsentPreferencesAvailable", () => {
    setConsentsDataOnUserProperty()
  })

  document.addEventListener("consentOptInDefaultAvailable", () => {
    setConsentsDataOnUserProperty()
  })
}
